import React from 'react'
import SocialiteHero from './SocialiteHero'
import ServiceDuty from './ServiceDuty'
import SocialWork from './SocialWork'
import ServiceGallery from './ServiceGallery'
import GivingBack from './GivingBack'

const SocialitePage = () => {
  return (
      <>
          <SocialiteHero />
      <ServiceDuty />
      <SocialWork />
      <ServiceGallery />
      <GivingBack/>
      </>
  )
}

export default SocialitePage